var map = {
	"./sidebar-_tem1.png": 974,
	"./sidebar-_tem10.png": 975,
	"./sidebar-_tem11.png": 976,
	"./sidebar-_tem12.png": 977,
	"./sidebar-_tem2.png": 978,
	"./sidebar-_tem3.png": 979,
	"./sidebar-_tem4.png": 980,
	"./sidebar-_tem5.png": 981,
	"./sidebar-_tem6.png": 982,
	"./sidebar-_tem7.png": 983,
	"./sidebar-_tem8.png": 984,
	"./sidebar-_tem9.png": 985
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 1154;


//////////////////
// WEBPACK FOOTER
// ./src/images ^\.\/sidebar\-_tem.*\.png$
// module id = 1154
// module chunks = 1